<template>
    <div>
      <b-progress :value="this.step" :max="this.NoOfSteps" variant="info"></b-progress>
      <div v-if="loaded">
      <component :is="stepComponent" @PageComplete="PageComplete" :DataPass='DataPass' :Type='Type' :ID='ID'/>
      <br/> 
      <b-row>
        <b-col><b-button variant="outline-dark" v-if="this.step>1" v-on:click="back">Back</b-button></b-col>
        <b-col> 
            <b-button variant="outline-info" v-if="this.stepComplete == false" v-on:click="next">Next</b-button>
            <b-button variant="outline-success" v-if="this.lastCompleted == true" v-on:click="finishWizard">Submit</b-button>
        </b-col>
      </b-row>
      </div>

    
    </div>
  </template>
  
  <script>
    import axios from "axios";
  export default {
    props:['DataPass','Type','ID'],
    data(){
        return{
        NoOfSteps: 2,
        step: 1,
        stepComplete: true,
        lastCompleted: null,
        userURN: localStorage.getItem('UserURN'),
        Location: localStorage.getItem('CurrentLocation'),
        initialData: "",
        DeviceName: "",
        ProbeArray: [],
        loaded: false,
        LookUpRequest: null,
        feedList: [],
        positionList: [],
          
        }
    },
    
    computed: {
      stepComponent() {
        this.step;
        return () => import(`@/components/CalibrationWizard/CALScreen${this.step}.vue`);
      }
    },
    beforeMount() {
  
    },
     mounted(){
       let DataLookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersFeed = this.$apikeyPost;
    let DataLookUpRequest = { RequestType: "PositionFeed" };
    axios
      .post(DataLookUpUrl, DataLookUpRequest, LookUpHeadersFeed)
      .then((response) => {
        this.feedList = response.data.Feeds;
        this.positionList = response.data.Positions;
      });

      let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpRequest = { 
      RequestType: "DeviceCalibration",
      DeviceID: this.ID,
      DataDict: [{
        "DeviceType": this.Type
      }] 
    };
    axios
      .post(LookUpUrl, LookUpRequest, LookUpHeaders)
      .then((response) => {
 
        let ResponseArray = response.data.Values
        
        this.DeviceName = ResponseArray[1]
        let ProbeValues = ResponseArray[3]

        this.ProbeArray = []
        for (let x=0;x < ProbeValues.length;x++){
          this.ProbeArray.push(
            {
              ProbeNo: ProbeValues[x][0],
              ProbeFeed: ProbeValues[x][2],
              ProbePosition: ProbeValues[x][3],
              ProbeRecirc: ProbeValues[x][4],
              ProbeTag: ProbeValues[x][5],
              ProbeTemp: "",
              ProbeFlow: ""
            }
          )
        }    
        this.DataPass = [],
        this.DataPass.push(this.ProbeArray)
        this.DataPass.push(this.DeviceID)
        this.DataPass.push(this.DeviceName)
        this.loaded = true

      });



    },
    methods: {
      next() {
        this.stepComplete = true;
        if (this.step < this.NoOfSteps){
            this.step++;
        }
        else{
            return;
        }
        
      },
      back(){
        this.step--;
      },
      SetValues(){

      },  
       PageComplete(page,data){

        if(page  == 1){      
          this.Type = data[0]
          this.ID = data[1]
          this.DataPass = data
          this.stepComplete = false;
        } else if (page == 2){
          this.DataPass = data
          this.stepComplete = false;
        }

        if (page == this.NoOfSteps){
          this.stepComplete = true;
          this.PassedValues = data;
          this.lastCompleted = true;
        }
      },
         
      finishWizard(){

        let RequestParam = ""

        if(this.PassedValues[0] == "O1"){
          RequestParam = "CalibrationO1Submit"
        }
        if(this.PassedValues[0] == "C1"){
          RequestParam = "CalibrationC1Submit"
        }

        let feedvalues = this.feedList
        let positionvalues = this.positionList
        let feednumber = ""
        let positionnumber = ""



        let ProbeList = [];
        let TempProbeArray = this.PassedValues[3][0]
        for (let x=0;x<TempProbeArray.length;x++){

          for (let y=0;y<feedvalues.length;y++){
                if(feedvalues[y][1] == TempProbeArray[x].ProbeFeed){
                  feednumber = feedvalues[y][0]
                }
            } 
            
            for (let z=0;z < positionvalues.length;z++){
                if(positionvalues[z][1] == TempProbeArray[x].ProbePosition){
                  positionnumber = positionvalues[z][0]
                }
            }

            ProbeList.push(
              [
                TempProbeArray[x].ProbeNo.toString(),
                feednumber.toString(),
                positionnumber.toString(),
                TempProbeArray[x].ProbeRecirc,
                TempProbeArray[x].ProbeTag,
                TempProbeArray[x].ProbeTemp,
                TempProbeArray[x].ProbeFlow
              ]
            )
          }
          this.LookUpRequest = { 
          RequestType: RequestParam,
          DeviceDict: [{
            "DeviceID": this.PassedValues[1],
            "ProbeList": ProbeList,
            "UserURN": this.userURN,
            "CalibrationDate": this.PassedValues[2].CalibrationDate,
            "CalibrationTime": this.PassedValues[2].CalibrationTime
          }] 
          };

        let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
        let LookUpHeaders = this.$apikeyPost;
        let finalLookUpRequest = this.LookUpRequest

        axios
            .post(LookUpUrl, finalLookUpRequest, LookUpHeaders)
            .then((response) => {
              response
            });
        this.$emit("WizardComplete");
      }

    }
  };
  </script>